import { render, staticRenderFns } from "./ParcelasTabela.vue?vue&type=template&id=4bf72cc8&scoped=true"
import script from "./ParcelasTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./ParcelasTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ParcelasTabela.vue?vue&type=style&index=0&id=4bf72cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf72cc8",
  null
  
)

export default component.exports